import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllGeneralSaleUserSuccess,
  getAllGeneralSaleUserFailed,
  GET_ALL_GENERAL_SALE_USER_START,
} from '../../actions/general'

/**
 * get list general sale user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListGeneralSaleUserApi = (props) => {
  var uri = `/users/general/sales`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListGeneralSaleUser(action) {
  try {
    const response = yield call(getListGeneralSaleUserApi, action?.payload)
    yield put(getAllGeneralSaleUserSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllGeneralSaleUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list general sale user
 */
export default function* watchGetListGeneralSaleUser() {
  yield takeLatest(GET_ALL_GENERAL_SALE_USER_START, doGetListGeneralSaleUser)
}
